import { render } from "./Shop.vue?vue&type=template&id=58322414&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=58322414&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58322414"]])

export default __exports__